import captureException from 'in-meeting-experience-ui-components/utils/captureException';
import { getInMeetingExperienceProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import { BASE_AVATAR_SIZE_PARAMS } from '../../constants/avatars';
import noAuthClient from '../../utils/apiClient';
const API_BASE = `${getInMeetingExperienceProxyApiUrl()}/v1/avatars/batch`;
export const getAvatars = data => noAuthClient.post(API_BASE, {
  data: Object.assign({
    sizeParams: BASE_AVATAR_SIZE_PARAMS
  }, data)
}).catch(captureException);